export default __webpack_public_path__ + "static/media/geology.c5a8a317.svg";